import Vuex from "vuex";
import router from './router.js'
import VxMain from "./components/VxMain";

const config = {
    install(Vue) {
        Vue.prototype.$icsilab = this
        this.vue = Vue
        this.init()
    },
    init: function () {
        this.baseUrl = (process.env.NODE_ENV === 'development') ? this.environnements.developpement.baseUrl : this.environnements.production.baseUrl
        this.site = 'wikaz'
        this.rootApi = this.baseUrl + 'api/icsilab/sites/' + this.site + '/'
        this.store = new Vuex.Store(this.optionStore)
        this.router = router
        this.currentRoute = 'home'
        this.chargerDataFromJson()
        return this
    },
    vue: null,
    site: null,
    baseUrl: null,
    rootApi: null,
    environnements: {
        production: {
            baseUrl: "https://api.wikaz.fr/"
        },
        developpement: {
            baseUrl: "http://wikaz-api.local/"
        }
    },
    optionVuetify: {
        theme: {
            dark: false
        },
        icons: {
            iconfont: "md"
        }
    },
    optionStore: {
        state: {
            test: null,
            config: null,
            datas: null,
            drawerMenu: false
        }
    },
    store: null,
    router: null,
    currentRoute: null,
    vuetify: null,
    tabRoutes: Array(),
    chargerDataFromJson () {
        this.store.state.datas = require('./lang/' + process.env.VUE_APP_LANG + '/data.json')
        document.title = this.store.state.datas.title
        this.addDescription( this.store.state.datas.description)
        this.addRoutes(this.store.state.datas.pages)
    },
    addRoutes: function (pagesData) {
        for (const property in pagesData) {
            if (property !== 'home' && !this.checkRouteExiste(property)) {
                this.router.addRoutes([{path: "/" + property,
                    name: property,
                    props: true,
                    component: VxMain}])
                this.tabRoutes.push(property)
            }
        }
        if (this.router.app && this.router.app._route.redirectedFrom) {
            let routeFrom = this.router.app._route.redirectedFrom.replace("/","")
            if (!this.checkRouteExiste(routeFrom)) {
                this.router.push({ name: routeFrom })
            }
        }
    },
    checkRouteExiste (route) {
        if (this.tabRoutes.indexOf(route) > -1) {
            return true;
        }
        return false;
    },
    chargeFavicon: function (src) {
        let link = document.createElement('link')
        let oldLink = document.getElementById('dynamic-favicon')
        link.rel = 'icon'
        link.href = src
        if (oldLink) {
            document.head.removeChild(oldLink)
        }
        document.head.appendChild(link)
    },
    addDescription: function (valeur) {
        let metaDescription = document.createElement('meta')
        let oldMetaDescription = document.getElementById('baliseDescription')
        metaDescription.id = 'baliseDescription'
        metaDescription.name = 'description'
        metaDescription.content = valeur
        if (oldMetaDescription) {
            document.head.removeChild(oldMetaDescription)
        }
        document.head.appendChild(metaDescription)
        //<meta name="description" content="Free Web tutorials">
    },
    setDrawerEtat: function (etat) {
        this.store.state.drawerMenu = etat
    },
    goToPage: function (route) {
        if (this.validURL(route)) {
            window.open(route, "_blank");
        } else {
            if (this.router.history.current.name !== route ) {
                this.vue.$ga.page('/' + route);
                this.currentRoute = route
                this.router.push({ name: route })
            }
        }
    },
    validURL: function (str) {
        var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return !!pattern.test(str);
    },
    getDatas: function () {
        return this.store.state.datas
    },
    getPages: function (route = null) {
        if (route) {
            return this.getDatas().pages[route]
        }
        return this.getDatas().pages
    },
    getHeader: function () {
        return this.getDatas().header
    },
    getFooter: function () {
        return this.getDatas().footer
    },
    getMentions: function () {
        return this.getDatas().mentions
    },
    getUrlImage (path) {
        return './' + path
    },
    getUrlFichier (path) {
        return './' + path
    }
};

export default config